<template>
    <div id="account-properties" v-if="!this.$parent.loading">
        <h4 v-if="subTitle"
            class="title is-4 tab-sub-title"
            :class="{'pull-left' : userCan('bulk_upload_account_properties', 'account_properties')}">
            {{ subTitle }}
        </h4>

        <div class="tab-actions" v-if="userCan('bulk_upload_account_properties', 'account_properties')">
            <b-button
                      type="is-info"
                      icon-pack="fas"
                      class="pull-right has-icon"
                      label="Import Properties"
                      icon-left="upload"
                      tag="router-link"
                      :to="{path: `/accounts/${this.$route.params.id}/import/`}" />
        </div>

        <datatable
                :export-prefix="account.name.value + ' - '"
                model="account_properties"
                modal="AccountProperty"
                :modalRoute="propertiesRoute"
                :filter="propertiesFilter"
                :transformTableRouteLink="prepareTableRouteLink"
                :transformCreateRouteLink="prepareCreateRouteLink"
        ></datatable>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import stringifyObject from '@/functions/stringifyObject'
import Datatable from '@/components/Elements/Datatable'

export default {
  name: 'AccountProperties',
  props: {
    account: {
      type: Object
    }
  },
  components: {
    Datatable: Datatable
  },
  data () {
    return {
      model: 'account_properties',
      propertiesRoute: {
        name: 'account-property',
        params: { id: this.$route.params.id, property_id: 'row_id' }
      },
      propertiesFilter: {
        'account_id': this.account.id
      }
    }
  },
  computed: {
    ...mapGetters({
      modelUpdatedAt: 'modelUpdatedAt',
      dataChanged: 'dataChanged',
      userCan: 'userCan',
      datatableSubTitle: 'datatableSubTitle'
    }),
    uniqueModel () { // used for state tracking for this specific instance
      let key
      if (this.propertiesFilter) key = stringifyObject(this.propertiesFilter)
      if (key) return this.model + '_' + stringifyObject(this.propertiesFilter)

      return this.model
    },
    subTitle: function () {
      return this.datatableSubTitle(this.uniqueModel)
    }
  },
  watch: {
    '$route.params.id': function (id) {
      this.$set(this, 'propertiesRoute', {
        name: 'account-property',
        params: { id: this.$route.params.id, property_id: 'row_id' }
      })
    }
  },
  methods: {
    handleError (err) {
      if (err.hasOwnProperty('response')) {
        if (err.response.data.response === 'error') {
          this.$awn.warning(err.response.data.message)
        }
      } else {
        this.$awn.alert(err.toString())
      }
    },
    prepareTableRouteLink (row, $route) {
      return `/accounts/${$route.params.id}/properties/${row.id}`
    },
    prepareCreateRouteLink ($route) {
      return `/accounts/${$route.params.id}/properties/create`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Account/Tabs/AccountProperties.vue